import { render, staticRenderFns } from "./LaudoBacenResolucao.vue?vue&type=template&id=3dd17d5c&scoped=true&lang=pug"
import script from "./LaudoBacenResolucao.vue?vue&type=script&lang=js"
export * from "./LaudoBacenResolucao.vue?vue&type=script&lang=js"
import style0 from "./LaudoBacenResolucao.vue?vue&type=style&index=0&id=3dd17d5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd17d5c",
  null
  
)

export default component.exports